import { Button } from "antd";
import formatPrice from "../../../components/formatPrice";
import datetimeParser from "../../../components/datetimeParser";
import DownloadXML from "./DownloadXML";
import CopyData from "../../../components/CopyData";
const columns = [
	{
		title: "ID wpływu",
		dataIndex: "msr_wplywy_own_id",
		width: "200px",
		key: "msr_wplywy_own_id",
		render: (item, record) => (
			<div className="monospace">
				<CopyData item={`#${item}`} /> #{item}
			</div>
		),
	},
	{
		title: "Imie i nazwisko osoby",
		width: "250px",
		dataIndex: "osoba",
		key: "osoba",
		render: (item, record) => (
			<div
				style={{
					fontSize: "14px",
					fontWeight: 500,
					display: "flex",
					gap: "10px",
				}}
			>
				<CopyData
					item={`#${record.msr_persons_own_id} ${record.msr_persons_name} ${record.msr_persons_lastname}`}
				/>
				<div
					style={{
						padding: "2px 5px",
						background: "rgb(233 233 233)",
						fontSize: "13px",
						color: "black",
						borderRadius: "5px",
						width: "fit-content",
						fontFamily: "Courier New, Courier, monospace",
						height: "fit-content",
					}}
				>
					#{record.msr_persons_own_id}
				</div>
				<div>
					{record.msr_persons_name} {record.msr_persons_lastname}
				</div>
			</div>
		),
	},
	{
		title: "Kwota rezerwy",
		dataIndex: "msr_reserves_amount",
		key: "msr_reserves_amount",
		width: "200px",
		render: (item, record) => (
			<div
				className="monospace"
				style={{
					fontSize: "14px",
					fontWeight: 700,
					textAlign: "right",
				}}
			>
				{formatPrice(item)} zł
			</div>
		),
	},
	{
		title: "Data dodania",
		dataIndex: "msr_reserves_own_id",
		key: "msr_reserves_own_id",
		render: (item, record) => (
			<div style={{ fontSize: "14px", fontWeight: 500 }}>
				{datetimeParser(item, "YYYY-MM-DD")}
			</div>
		),
	},
	{
		title: "Dodane przez",
		dataIndex: "msr_reserves_user",
		key: "msr_reserves_user",
		render: (item, record) => (
			<div style={{ fontSize: "14px", fontWeight: 500 }}>
				{record?.userDetails?.mlg_users_fullname}
			</div>
		),
	},
	{
		title: "Opis rezerwy",
		dataIndex: "msr_reserves_comment",
		key: "msr_reserves_comment",
		render: (item) => <div style={{ fontSize: "13px" }}>{item || "-"}</div>,
	},
];

export default columns;
